import { withJsonFormsControlProps } from "@jsonforms/react";
import SelectField from "./SelectField";

const SelectComponent = (props) => {
  const { handleChange, label, data, path, errors, schema, uischema, required } =
    props;
  return (
    <SelectField
      value={data}
      label={label}
      updateValue={(newVal) => handleChange(path, newVal || "")}
      errors={errors}
      schema={schema}
      uiSchema={uischema}
      required={required}
    />
  );
};

export const SelectControl = withJsonFormsControlProps(SelectComponent);
